import React, { useContext, useEffect, useMemo } from 'react'

import { DataContext } from '../../../explorer/map/DataContext'
import SubmissionsMapHeader from '../submissionsMap/SubmissionsMapHeader'
import ExplorerMap from '../../../explorer/map/ExplorerMap'
import { DataContext as SubmissionsDataContext } from '../../DataContext'
import { AppStateContext } from '../../../explorer/AppStateContext'
import MapLayerControls from '../../../explorer/map/layers/MapLayerControls'
import VectorSource from 'ol/source/Vector'

export default () => {
    const {
        getFeatureWithLatLong,
        latLongFeature,
        setIsSubmissionsMap,
        filteredData,
        setFilteredData,
        source,
    } = useContext(DataContext)
    const {
        mapState: { map },
        setMapState,
    } = useContext(AppStateContext)
    const { submissionState, activePanel } = useContext(SubmissionsDataContext)

    useEffect(() => setIsSubmissionsMap(true), [])

    useEffect(() => {
        if (
            submissionState &&
            submissionState.uploadFacilityMerge &&
            submissionState.uploadFacilityMerge.length &&
            activePanel === 'View in Map'
        ) {
            const facilities = submissionState.uploadFacilityMerge
            const facilitiesToAdd = facilities.map(x => x.ClearinghouseNumber)
            setFilteredData(facilitiesToAdd)
            const primaryFacility = facilities.find(
                x =>
                    x.IsPrimary === true ||
                    x.IsPrimary === 'true' ||
                    x.IsPrimary === 1
            )
            if (primaryFacility) {
                getFeatureWithLatLong(
                    null,
                    null,
                    primaryFacility.ClearinghouseNumber,
                    true
                )
            }
        }
    }, [submissionState, activePanel])

    // Zoom to extent of filtered features
    useEffect(() => {
        // if (latLongFeature && map) {
        //     // Zoom to extent of filtered features
        //     map.updateSize()
        //     map.getView().fit(latLongFeature.getGeometry(), {
        //         minResolution: 15,
        //     })
        // } else 
        if (filteredData && map && source) {
            // Get features from the existing source
            const allFeatures = source.getFeatures()

            // Filter features where isdisplayed = 1
            const displayedFeatures = allFeatures.filter(feature => {
                const properties = feature.getProperties()
                return properties.displayed === 1
            })

            // Create a new source with filtered features
            const filteredSource = new VectorSource({
                features: displayedFeatures,
            })

            // Zoom to extent of filtered features
            map.updateSize()
            if (displayedFeatures.length > 0) {
                const extent = filteredSource.getExtent()
                map.getView().fit(extent, {
                    padding: [50, 50, 50, 50],
                    duration: 500,
                })
            }
        }
    }, [latLongFeature, filteredData, source, map])

    return (
        <div className="mt-5">
            <div
                className={`${
                    activePanel === 'View in Map' ? '' : 'is-hidden'
                } `}
            >
                <SubmissionsMapHeader />
                <MapLayerControls mapMenu={`SubmissionsMap`} />
                <ExplorerMap />
            </div>
        </div>
    )
}
